import { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { Box, Grid, MenuItem, Modal, Select, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";
import MDModal from "components/MDModal";
import { useCustomer } from "context/CustomerContext";
import { genderOptions } from "constants/CodConstants";
import axios from "axios";
import { useHookFormMask, withMask } from "use-mask-input";
import MDSelect from "components/MDSelect";
import CustomerPhonesForm from "components/CustomerPhonesForm";

function CustomersForm({ setShowForm }) {
  const [disable, setDisable] = useState(true);
  const [dataCustomerPhones, setDataCustomerPhones] = useState([]);
  const [formPhones, setFormPhones] = useState([]);
  const { storeCustomer, updateCustomer, editCustomer, setEditCustomer, loading, setLoading } =
    useCustomer();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      gender: "MASCULINO", // valor padrão definido
    },
  });

  const registerWithMask = useHookFormMask(register);

  const gender = watch("gender");
  const cep = watch("cep");

  const onHandleSubmit = (data) => {
    data["phones"] = dataCustomerPhones;
    if (Object.keys(editCustomer).length != 0) {
      setShowForm(false);
      return updateCustomer(data);
    }
    setEditCustomer({});
    storeCustomer(data);
    setShowForm(false);
  };

  const onCancelEditCustomer = () => {
    setEditCustomer({});
    reset({
      name: "",
      cpf: "",
      address: "",
      district: "",
      state: "",
      city: "",
      cep: "",
      gender: "",
    });
  };

  useEffect(() => {
    reset(editCustomer);
    setFormPhones(editCustomer.phones);
  }, [editCustomer]);

  const fetchAddress = async (cep) => {
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
      const { logradouro, bairro, localidade, uf } = response.data;
      //reset({ address: logradouro, city: localidade, state: uf });
      setValue("address", logradouro);
      setValue("city", localidade);
      setValue("district", bairro);
      setValue("state", uf);
      setDisable(false);
    } catch (error) {
      console.error("Erro ao buscar CEP:", error);
    }
  };

  useEffect(() => {
    if (cep?.length === 0) {
      setValue("address", "");
      setValue("city", "");
      setValue("district", "");
      setValue("state", "");
      setDisable(true);
    }
    if (cep && cep.length > 7) {
      fetchAddress(cep);
    }
  }, [cep, setValue]);

  return (
    <MDBox sx={{ p: 2 }}>
      <Grid
        container
        spacing={2}
        component="form"
        onSubmit={handleSubmit(onHandleSubmit)}
        role="form"
      >
        <Grid item xs={12}>
          <MDInput
            variant="outlined"
            required
            fullWidth
            id="name"
            label="Nome"
            name="name"
            {...register("name")}
            // value={formData.name}
            // onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <MDInput
            variant="outlined"
            fullWidth
            id="social_name"
            label="Nome Social"
            name="social_name"
            {...register("social_name")}
            // value={formData.name}
            // onChange={handleChange}
          />
        </Grid>
        <Grid item xs={8}>
          <MDInput
            variant="outlined"
            fullWidth
            id="cpf"
            label="CPF"
            name="cpf"
            {...register("cpf")}
            // value={formData.cpf}
            // onChange={handleChange}
          />
        </Grid>
        <Grid item xs={2}>
          <MDSelect
            select
            variant="outlined"
            fullWidth
            id="gender"
            label="Genero"
            placeholder="Genero"
            name="gender"
            value={gender}
            options={genderOptions}
            onChange={(e) => setValue("gender", e.target.value)}
            {...register("gender")}
          />
          {/* <Select
            select
            variant="outlined"
            fullWidth
            id="gender"
            label="Genero"
            placeholder="Genero"
            name="gender"
            value="MASCULINO"
            onChange={(e) => setValue("gender", e.target.value)}
            {...register("gender")}
            // onChange={handleChange}
          >
            {genderOptions.map((option, index) => (
              <MenuItem key={index} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select> */}
        </Grid>
        <Grid item xs={2}>
          <MDInput
            variant="outlined"
            fullWidth
            id="cep"
            label="Cep"
            name="cep"
            {...register("cep")}
            // value={formData.cep}
            // onChange={handleChange}
          />
        </Grid>
        <Grid item xs={6}>
          <MDInput
            variant="outlined"
            fullWidth
            id="address"
            label="Endereço"
            name="address"
            disabled={disable}
            {...register("address")}
            // value={formData.address}
            // onChange={handleChange}
          />
        </Grid>
        <Grid item xs={6}>
          <MDInput
            variant="outlined"
            fullWidth
            id="district"
            label="Setor"
            name="district"
            disabled={disable}
            {...register("district")}
            // value={formData.district}
            // onChange={handleChange}
          />
        </Grid>
        <Grid item xs={3}>
          <MDInput
            variant="outlined"
            fullWidth
            id="city"
            label="Cidade"
            name="city"
            disabled={disable}
            {...register("city")}
            // value={formData.city}
            // onChange={handleChange}
          />
        </Grid>
        <Grid item xs={3}>
          <MDInput
            variant="outlined"
            fullWidth
            id="state"
            label="Estado"
            name="state"
            disabled={disable}
            {...register("state")}
            // value={formData.state}
            // onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomerPhonesForm
            formPhones={formPhones}
            setFormPhones={setFormPhones}
            setData={setDataCustomerPhones}
          />
        </Grid>
        <Grid item xs={12} spacing={2}>
          {Object.keys(editCustomer).length == 0 ? (
            <MDButton
              type="submit"
              disabled={loading}
              fullWidth
              variant="contained"
              color="primary"
            >
              Enviar
            </MDButton>
          ) : (
            <>
              <MDButton type="submit" variant="contained" color="primary">
                Editar
              </MDButton>
              <MDButton variant="contained" color="primary" onClick={onCancelEditCustomer}>
                Cancelar
              </MDButton>
            </>
          )}
        </Grid>
      </Grid>
    </MDBox>
  );
}

CustomersForm.propTypes = {
  setShowForm: PropTypes.func,
};

export default CustomersForm;
